<div class="share-label" [title]="securityType().class">
  <span class="class">{{ securityType().class }}</span><span [hidden]="hidePrice"
  class="paid-unpaid">&#64;{{ nominalPrice() }}
  /{{ unpaidAmount() }}</span>
  <ng-content></ng-content>
</div>
